import { Panel } from 'primereact/panel';
import ContentLoadingTemplate from '@/Components/Templates/ContentLoadingTemplate';
import {apiRequest, formatDate, toast} from '@/Helpers/general';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import {InputSwitch} from "primereact/inputswitch";
import React, {useContext, useState} from "react";
import {AppContext} from "@/Components/Context/AppContext";

const ClaimsSummary = ({ tab, formData, formLoading, request, reloadCaseData }) => {
    const { toastRef } = useContext(AppContext);
    const [localFormLoading, setLocalFormLoading] = useState(false);

    const switchItems = (field, formData) => {
        switch (field.type) {
            case 'text':
                return formData[field.tab] && formData[field.tab][field.name] ? formData[field.tab][field.name] : ''
            case 'date':
                if (Array.isArray(formData[field.tab][field.name])) { //for hire_start_date/hire_end_date
                    return formData[field.tab][field.name] && formData[field.tab][field.name][0] ? formatDate(formData[field.tab][field.name][0], true) : ''
                }
                return formData[field.tab] && formData[field.tab][field.name] ? formatDate(formData[field.tab][field.name], true) : ''
            case 'boolean':
                if (formData[field.tab]) {
                    if (formData[field.tab][field.name] === 1) {
                        return 'Yes';
                    } else if (formData[field.tab][field.name] === 0) {
                        return 'No';
                    }
                }
                return '';
            default:
                return ''
        }
    };

    const onViewModeChange = async (e) => {
        setLocalFormLoading(true)
        await apiRequest('post', 'request/' + request.id + '/switch-view-mode', {
            data: {
                'advanced_view': e.value
            },
            onSuccess: (response) => {
                setLocalFormLoading(false);
                reloadCaseData()
                toast(toastRef, 'success', 'View mode successfully changed.');
            },
            onFailure: (error) => {
                setLocalFormLoading(false);
                 if (error.status === 403) {
                    toast(toastRef, 'error', 'Error: the case needs to be assigned in order to save data.');

                } else {
                    toast(toastRef, 'error', 'Error while changing view mode.');
                }
            }
        });
    }

    const header = (category) => {
        if(category.key === 'administration'){
            return <div className='flex justify-content-between' style={{width: '100%'}}>
                <span className='align-self-center'>{category.name}</span>
                <div className='flex justify-content-center align-items-center gap-2'>
                    <span className='font-semibold'>Simple</span>
                    <InputSwitch
                        id='switch-view-mode'
                        checked={request.advanced_view}
                        disabled={localFormLoading}
                        onChange={onViewModeChange}
                    />
                    <span className='font-semibold'>Advanced</span>
                </div>
            </div>
        }
        return category.name
    }

    return (
        <div className="general-form relative claims-summary">
            {tab.fields.map((category) => {
                return (
                    <Panel header={header(category)} key={category.key}>
                        <table>
                            <tbody>
                            {category.fields.map((field) => {
                                    return (
                                        <tr key={field.name}>
                                            <td className="my-2 font-bold text-left">{field.label}</td>
                                            <td className="my-2 text-left">{switchItems(field, formData)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </Panel>
                );
            })}
            {(localFormLoading || formLoading) && <ContentLoadingTemplate />}
        </div>
    );
};

export default ClaimsSummary;
